module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFabricio) ? _c('div', {
    staticClass: "importar-preventivas"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.carregando && _vm.acaoEmProgresso !== 'calcular-base24-25') ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Importando dados, por favor aguarde...")])]) : (_vm.erro) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.erro) + "\n      ")]) : (_vm.resultadoImportacao) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('h4', [_vm._v("Ação concluída!")]), _vm._v(" "), (_vm.resultadoImportacao.message) ? _c('p', [_vm._v(_vm._s(_vm.resultadoImportacao.message))]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados) ? _c('div', [_c('p', [_vm._v("Registros afetados:")]), _vm._v(" "), _c('ul', [(_vm.resultadoImportacao.dados_importados.base24_25 !== undefined) ? _c('li', [_c('strong', [_vm._v("Base24_25:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.base24_25) + " registros")]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados.valores_mensais_predios_2025 !== undefined) ? _c('li', [_c('strong', [_vm._v("Valores Mensais Prédios 2025:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.valores_mensais_predios_2025) + " registros")]) : _vm._e(), _vm._v(" "), (_vm.resultadoImportacao.dados_importados.valores_faturamento !== undefined) ? _c('li', [_c('strong', [_vm._v("Valores Faturamento:")]), _vm._v(" " + _vm._s(_vm.resultadoImportacao.dados_importados.valores_faturamento) + " registros")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mt-3",
    on: {
      "click": _vm.limparResultado
    }
  }, [_vm._v("Nova ação")])]) : _c('div', [(_vm.statusDados) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('h4', [_vm._v("Status Atual:")]), _vm._v(" "), _c('div', {
    staticClass: "card bg-light p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Base24_25")]), _vm._v(" "), (_vm.statusDados.base24_25.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.base24_25.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Valores Mensais Prédios 2025")]), _vm._v(" "), (_vm.statusDados.valores_mensais_predios_2025.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.valores_mensais_predios_2025.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-3"
  }, [_c('h5', [_vm._v("Valores Faturamento")]), _vm._v(" "), (_vm.statusDados.valores_faturamento && _vm.statusDados.valores_faturamento.tem_dados) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                  Existem " + _vm._s(_vm.statusDados.valores_faturamento.total) + " registros na tabela.\n                ")]) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  Não existem registros na tabela.\n                ")])])])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-3"
  }, [_c('div', {
    staticClass: "btn-group mb-2",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarBase2425
    }
  }, [(_vm.acaoEmProgresso === 'importar-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarValores2025
    }
  }, [(_vm.acaoEmProgresso === 'importar-valores-2025') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Valores 2025")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.importarValoresFaturamento
    }
  }, [(_vm.acaoEmProgresso === 'importar-valores-faturamento') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Importando...")]) : _c('span', [_vm._v("Importar Valores Faturamento")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group mb-2 ml-2",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparBase2425
    }
  }, [(_vm.acaoEmProgresso === 'limpar-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparValores2025
    }
  }, [(_vm.acaoEmProgresso === 'limpar-valores-2025') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Valores 2025")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.limparValoresFaturamento
    }
  }, [(_vm.acaoEmProgresso === 'limpar-valores-faturamento') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Limpando...")]) : _c('span', [_vm._v("Limpar Valores Faturamento")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularBase2425()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Base24_25")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularValorFixoMensal()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-valor-fixo-mensal') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Valor Fixo Mensal - Faturamento")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularValorFixoMensalRestante()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-valor-fixo-mensal-restante') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Valor Fixo Mensal - Restante")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.calcularCamposDerivadosBase()
      }
    }
  }, [(_vm.acaoEmProgresso === 'calcular-campos-derivados-base24-25') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Calculando...")]) : _c('span', [_vm._v("Calcular Campos Derivados")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.ajustarValorFixoZero()
      }
    }
  }, [(_vm.acaoEmProgresso === 'ajustar-valor-fixo-zero') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Ajustando...")]) : _c('span', [_vm._v("Ajustar Valor Fixo = 0")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoQteProgramada()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-qte-programada') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("1) Recalcular Período - Qte Programada")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoQtesEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-qtes-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("2) Recalcular Período - Entregue + Não entregues")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoTaxaEntrega()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-taxa-entrega') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("3) Recalcular Período - Taxa entrega")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("4) Recalcular Período - Soma valores ENTREGUES")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresNaoEntregues()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("5) Recalcular Período - Soma valores NÃO ENTREGUES")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresEntreguesDispersos()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-entregues-dispersos') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("6) Recalcular Período - Soma ENTREGUES Dispersos")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.recalcularPeriodoSomaValoresNaoEntreguesDispersos()
      }
    }
  }, [(_vm.acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues-dispersos') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Recalculando...")]) : _c('span', [_vm._v("7) Recalcular Período - Soma NÃO ENTREGUES Dispersos")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": function($event) {
        return _vm.exportarBaseSimulacao()
      }
    }
  }, [(_vm.acaoEmProgresso === 'export-base-simulacao') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Exportando...")]) : _c('span', [_vm._v("Final) Exportar Base + Simulação")])]), _vm._v(" "), (_vm.pendentesInfo) ? _c('span', {
    staticClass: "badge badge-warning ml-2",
    attrs: {
      "title": "Pendentes na outbox + pendências de cálculo na base"
    }
  }, [_vm._v("\n            Pendentes: " + _vm._s(_vm.pendentesInfo.pendentes_total) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaCalcularValorFixoMensal
    }
  }, [_vm._v("\n                1) Valor Fixo (faturamento)\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaAjustarZero
    }
  }, [_vm._v("\n                2) Ajustar Valor Fixo = 0\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.etapaCalcularDerivados
    }
  }, [_vm._v("\n                3) Campos Derivados\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.carregarPendentes
    }
  }, [_vm._v("\n                Atualizar Pendentes\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.carregando || _vm.acaoEmProgresso !== null
    },
    on: {
      "click": _vm.executarEtapasPreExport
    }
  }, [_vm._v("\n              Executar etapas 1-3\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/simulacao-geral')
      }
    }
  }, [_vm._v("Voltar para Simulação")])])])])])])]) : _c('div', {
    staticClass: "alert alert-warning m-3"
  }, [_vm._v("Acesso restrito.")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v("Importar Dados de Preventivas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h5', [_vm._v("Arquivo para importação:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Preventivas_2024_2025.xls")])]), _vm._v(" "), _c('p', [_vm._v("Este arquivo já está disponível no servidor e será importado diretamente sem necessidade de upload.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a74ed8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/simulacaoPreventivas/ImportarPreventivas.vue
// module id = 1008
// module chunks = 1